import { render, staticRenderFns } from "./SubRoomPresenter.vue?vue&type=template&id=76452831&scoped=true"
import script from "./SubRoomPresenter.vue?vue&type=script&lang=ts"
export * from "./SubRoomPresenter.vue?vue&type=script&lang=ts"
import style0 from "./SubRoomPresenter.vue?vue&type=style&index=0&id=76452831&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76452831",
  null
  
)

export default component.exports